import { AfterViewInit, Directive, ElementRef, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { MatFormField } from '@angular/material/form-field';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppState } from 'src/app/app.reducer';
import { DepartmentOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { NgrxEagerSelectService } from '../../select/eager-select/ngrx-eager-select-status.service';
import { LcsSingleSelectDirective } from '../../single-select/single-select.directive';
import { departmentOptionActions } from '../state/department-option.actions';
import { departmentOptionSelectors } from '../state/department-option.reducer';

@Directive({
    selector: '[ndtDepartmentSelect]',
    standalone: false
})
export class DepartmentSelectInputDirective implements OnDestroy, AfterViewInit {
   @Input() accountId: number | null;

   @Input() additionalFields: string[] | null;

   @Input() urlOverride?: string;

   protected destroyed$ = new Subject<void>();

   constructor(
      protected elementRef: ElementRef,
      protected formField: MatFormField,
      protected trigger: LcsSingleSelectDirective<DepartmentOption>,
      protected statusService: NgrxEagerSelectService<AppState, DepartmentOption>,
      protected store: Store<AppState>
   ) {}

   ngAfterViewInit(): void {
      this.statusService
         .initialize(
            this.formField,
            this.trigger,
            this.elementRef.nativeElement,
            departmentOptionActions,
            departmentOptionSelectors,
            () => {
               return this.additionalFields;
            },
            () => {
               return this.urlOverride;
            },
            () => {
               return this.statusService.buildPrimaryKeyFilterExpression('departmentId', this.trigger);
            },
            this.buildFilters()
         )
         .pipe(takeUntil(this.destroyed$))
         .subscribe();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.accountId) {
         this.store.dispatch(
            departmentOptionActions.load({
               additionalFields: this.additionalFields,
               filterOverrides: this.buildFilters(),
               urlOverride: this.urlOverride,
            })
         );
      }
   }

   buildFilters(): string[] {
      let staticFilterOverride: string[] = [];
      if (this.accountId) {
         staticFilterOverride.push(`AccountId = ${this.accountId}`);
      }
      return staticFilterOverride;
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }
}
